/**
 * The name of the patient a person has just removed, held for the page they land on. Removing goes
 * back to the clinic home, which says who was removed once and then forgets. A name that was never
 * taken, because the move was cancelled or redirected, goes stale after ten seconds so it cannot
 * turn up on a later visit.
 */
const STALE_MS = 10_000;

let removed: { readonly name: string; readonly at: number } | null = null;

export function rememberRemoved(name: string): void {
  removed = { name, at: Date.now() };
}

export function takeRemoved(): string | null {
  const held = removed;

  removed = null;

  return held !== null && Date.now() - held.at < STALE_MS ? held.name : null;
}
